import React from 'react';
import { HeartIcon, StarIcon } from 'lucide-react';
import { Section } from './Shared';
import { Blossom, Daisy } from './FloralDecor';
import { reviews } from '../data/reviews';
import type { Review } from '../types/product';
const accents: Record<Review['accent'], string> = {
  rose: 'bg-rose-100 text-rose-800',
  violet: 'bg-violet-100 text-violet-800',
  amber: 'bg-amber-100 text-amber-800'
};
export function Reviews() {
  return <Section id="reviews" data-id="element-321" data-mp="2w9d5hmkce8ld">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-322" data-mp="2w821pmqwd0u9">
        <Daisy className="absolute left-[3%] top-12 h-14 w-14" petalClassName="text-amber-100" centerClassName="text-amber-400" data-id="element-323" data-mp="3093vho21okou" />
        <Blossom className="absolute bottom-10 right-[4%] h-16 w-16" petalClassName="text-pink-200" centerClassName="text-amber-300" data-id="element-324" data-mp="3a1t4mca4hmh0" />
      </div>

      <h2 className="mx-auto mb-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-2 text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-325" data-mp="3f27apos5ymce">
        <HeartIcon className="h-7 w-7 fill-rose-600 text-rose-600" aria-hidden="true" data-id="element-326" data-mp="2rdgprxqiafwi" />
        Commenti di chi ha acquistato il kit in America Latina
      </h2>

      <ul className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-327" data-mp="2he7xd9bah9c9">
        {reviews.map(review => <li key={review.name} data-id="element-328" data-mp="2dcw854wbuq4l">
            <figure className="flex h-full flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm" data-id="element-329" data-mp="2ddxui5ismz1m">
              <div className="flex gap-0.5 text-amber-400" aria-label="Valutazione 5 su 5" data-id="element-330" data-mp="3a1u3ao7zoq2a">
                {Array.from({
              length: 5
            }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-331" data-mp="30d3t4p2spvs7" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-700 md:text-base" data-id="element-332" data-mp="2wcjv7jaeeo50">
                «{review.text}»
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-stone-200 pt-4" data-id="element-333" data-mp="3svhie0a2g9fo">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${accents[review.accent]}`} aria-hidden="true" data-id="element-334" data-mp="3o13f7bp5wy0g">
                  {review.initials}
                </span>
                <span data-id="element-335" data-mp="1cg4e3kniv0re">
                  <span className="block text-sm font-semibold text-stone-900" data-id="element-336" data-mp="1cejevhq9itn7">{review.name}</span>
                  <span className="block text-xs text-stone-500" data-id="element-337" data-mp="1hdmegmnh47ns">
                    {review.location} · {review.role}
                  </span>
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>
    </Section>;
}